import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useLocation } from 'react-router-dom';
import { Radar, Users, Plus, CalendarCheck, User } from 'lucide-react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setActiveTab, openBottomSheet } from '../../store/slices/uiSlice';
import { clearNew } from '../../store/slices/meetingsSlice';
import { useTelegram } from '../../hooks/useTelegram';
const tabs = [
    { id: 'feed', icon: Radar, label: 'Маяк', path: '/feed' },
    { id: 'people', icon: Users, label: 'Люди', path: '/people' },
    // Create button handled separately
    { id: 'meetings', icon: CalendarCheck, label: 'Встречи', path: '/meetings' },
    { id: 'profile', icon: User, label: 'Профиль', path: '/profile' },
];
export function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { hapticImpact } = useTelegram();
    const { active, incoming, personalIncoming, hasNew } = useAppSelector((s) => s.meetings);
    const unreadChats = active.filter((m) => m.hasUnread).length;
    const badgeCount = incoming.length + personalIncoming.length + unreadChats;
    const handleTab = (tab) => {
        if (!isActive(tab.path)) {
            hapticImpact('light');
        }
        if (tab.id === 'meetings') {
            dispatch(clearNew());
        }
        dispatch(setActiveTab(tab.id));
        navigate(tab.path);
    };
    const handleCreate = () => {
        hapticImpact('medium');
        dispatch(openBottomSheet('createBeacon'));
    };
    const isActive = (path) => location.pathname === path;
    return (_jsxs("nav", { className: "fixed bottom-0 left-0 right-0 z-50 flex", style: {
            background: '#0A0A0A',
            borderTop: '1px solid rgba(255,255,255,0.06)',
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
        }, children: [tabs.slice(0, 2).map((tab) => (_jsx(NavItem, { icon: tab.icon, label: tab.label, active: isActive(tab.path), onClick: () => handleTab(tab) }, tab.id))), _jsxs("div", { className: "flex-1 flex flex-col items-center gap-0.5 py-2 cursor-pointer", onClick: handleCreate, children: [_jsx("div", { className: "w-8 h-8 rounded-full flex items-center justify-center", style: {
                            background: '#EC4899',
                            boxShadow: '0 0 16px rgba(236,72,153,.35)',
                        }, children: _jsx(Plus, { className: "w-[18px] h-[18px] text-white" }) }), _jsx("span", { className: "text-[10px] font-medium text-white/50", children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C" })] }), tabs.slice(2).map((tab) => (_jsx(NavItem, { icon: tab.icon, label: tab.label, active: isActive(tab.path), badge: tab.id === 'meetings' ? badgeCount : undefined, pulse: tab.id === 'meetings' && hasNew, onClick: () => handleTab(tab) }, tab.id)))] }));
}
function NavItem({ icon: Icon, label, active, badge, pulse, onClick, }) {
    return (_jsxs("div", { className: "flex-1 flex flex-col items-center gap-0.5 py-2 cursor-pointer transition-colors relative", style: { color: active ? '#fff' : 'rgba(255,255,255,0.5)' }, onClick: onClick, children: [_jsxs("div", { className: "relative", children: [_jsx(Icon, { className: "w-5 h-5" }), badge != null && badge > 0 && (_jsx("span", { className: `badge-notify${pulse ? ' badge-pulse' : ''}`, children: badge }))] }), _jsx("span", { className: "text-[10px] font-medium", children: label }), active && (_jsx("div", { className: "absolute bottom-0.5 w-1 h-1 rounded-full", style: { background: '#EC4899' } }))] }));
}
